<template>
   <div class="logo-container">
  <img alt="company logo" src="./assets/Logo_3.png" class="logo-image">
  <router-view />
   </div> 
</template>

<script>
//import { ApiService } from "./apiService";
//const ApiService_ = new ApiService();

export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.logo-image {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px; /* Adjust size as needed */
} 
</style>
